module.exports = __webpack_public_path__ + "static/media/emma.679816f4.jpeg";